import { Upload } from "antd";
import React from "react";
import api from "../../api";
import { useToast } from "../toast/toast";
import { BeforeUpload } from "./BeforeUpload";

const UploadImage = ({ label, value, onUpload }) => {
  const toast = useToast();
  const beforeUpload = BeforeUpload();

  const files = value
    ? [{ uid: "-1", name: "image.jpg", status: "done", url: value }]
    : [];

  return (
    <div style={{ marginBottom: 12 }}>
      <p style={{ marginBottom: 6 }}>{label}</p>
      <Upload
        listType="picture-card"
        maxCount={1}
        fileList={files}
        beforeUpload={beforeUpload}
        onRemove={() => onUpload("")}
        customRequest={async ({ file, onSuccess, onError }) => {
          try {
            const formData = new FormData();
            formData.append("image", file);
            const res = await api.upload_image(formData);
            const url = res.data.url;
            onUpload(url); // parent-руу буцаана
            onSuccess(res, file);
            // toast("Зураг амжилттай нэмэгдлээ", "success");
          } catch (err) {
            toast("Upload амжилтгүй боллоо", "error");
            onError(err);
          }
        }}
      >
        {files.length === 0 && "+ Зураг"}
      </Upload>
    </div>
  );
};

export default UploadImage;
